<template> 
  <div style="background-color:white">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/oti_1.jpg" alt="" height="400" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;padding-right:0px">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Overseas Travel Insurance</p>
            <p style="font-size:24px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">(For both Business and Personal Trips)</p>
          </div>
          <div style="padding-top:20px">
            <h5>Cover:</h5>
            <p><span class="mdi mdi-check"> Financial losses due to travel changes, cancellation or interruption</span></p>
            <p><span class="mdi mdi-check"> Medical expenses, baggage delays or theft</span></p>
            <p><span class="mdi mdi-check"> Liability cover, accidental death or disability</span></p>
            <p><span class="mdi mdi-check"> Transportation delays.</span></p>
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(3)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'OverseasTravel',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

